export enum Relationship {
  Self = '001',
  Child = '002',
  Spouse = '003',
  Father = '004',
  Mother = '005',
  Brother = '006',
  Sister = '007',
  Nephew = '008',
  Uncle = '009',
  Financial = '010',
  Aunty = '011',
  Niece = '012',
  Friend = '013',
  GrandFather = '014',
  GrandMother = '015',
  GrandChild = '016',
  StepMother = '017',
  StepFather = '018',
  StepBrother = '019',
  StepSister = '020',
  Partner = '021',
  BrotherInLaw = '023',
  SisterInLaw = '024',
  Employer = '025',
  Daughter = '026',
  Son = '027',
  StepDaughter = '028',
  StepSon = '029',
  AdoptedDaughter = '030',
  AdoptedSon = '031',
  GrandDaughter = '032',
  GrandSon = '033',
  GodDaughter = '034',
  GodSon = '035',
  GodFather = '036',
  GodMother = '037',
  FosterFather = '038',
  FosterMother = '039',
  FatherInLaw = '040',
  MotherInLaw = '041',
  SonInLaw = '042',
  DaughterInLaw = '043',
  CousinBrother = '044',
  CousinSister = '045',
  FianceOrFiancee = '046',
  Husband = '047',
  Wife = '048',
  LegalGuardian = '049',
  Relative = '050',
  Others = '051',
  AffinityGroup = '052',
  EmployerGroup = '053',
  OtherFamily = '054',
}
